
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import homeModal from "./home-modal.vue";
import { State } from "vuex-class";
import maxNumber from "@/components/max-number/max-number.vue";
import { getMerchantIncome } from "@/api/api-operation-service";
// getMerchantIncome
@Component({
  components: {
    "pi-home-modal": homeModal,
    "pi-max-number": maxNumber
  }
})
export default class PiHomeAssetInfo extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private formData!: objAny;
  @State("sys") sys!: objAny;
  @Prop({
    default: () => {
      return {};
    }
  })
  private data!: objAny;
  private revenueCount: objAny = {};

  async getMerchantIncome() {
    const ret = await getMerchantIncome({});
    if (ret.status === this.$config.apiStatus) {
      this.revenueCount = ret.data[0];
    }
  }
  mounted() {
    this.getMerchantIncome();
  }
}
